import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import i18n from '../../../../i18n'
import { useTranslation } from 'react-i18next'
import { appAddress } from '../../../../App'

export default function Promote() {
  const {t} = useTranslation()

  const {id} = useParams()
  const navigate = useNavigate();
  const [editUser, setEditUser] = useState([])

  const users = useSelector(state => state.users)
  const token = useSelector(state => state.token)

  const [chechAdmin, setCheckAdmin] = useState(false)
  const [err, setErr] = useState(false)
  const [success, setSuccess] = useState(false)
  const [num, setNum] = useState(0)

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);

  useEffect(()=>{
    if(users.length !== 0){
      users.forEach(user => {
        if(user._id === id){
          setEditUser(user)
          setCheckAdmin(user.role === 1 ? true : false)
        }
      })
    } else {
      navigate('/users')
    }
  },[users, id, navigate])


  const handleUpdate = async ()=>{
    try {
      if(num % 2 !== 0){
        const res = await axios.put(`${appAddress}/user/update_role/${editUser._id}`, {
        // const res = await axios.put(`/user/update_role/${editUser._id}`, {
          role: chechAdmin ? 1 : 0
        }, {
          headers: {Authorization: token}
        })

        toast.success(res.data.msg, {
          position:"bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
              });
          setSuccess(res.data.msg)
              
          setNum(0)

          setTimeout(() =>{
            navigate('/users')
          }, 2000)
      }
    } catch (err) {
      toast.error(err.response.data.msg, {
                
        position:"bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
            progress: undefined,
        });
         setErr(err.response.data.msg)
    }
  }


  const handleCheck = () => {
    setSuccess('')
    setErr('')
    setCheckAdmin(!chechAdmin)
    setNum(num + 1)
  }

  return (
    <div className='bg-[#2a3447] text-teal-50 h-[100vh] flex justify-center items-center'>
    <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl
            pauseOnFocusLoss
            draggable
            pauseOnHover/>
      <div className='border border-slate-400 w-[30%] h-[30%] flex flex-col justify-center items-center'>
          <h2 className='mb-3 text-2xl font-englishTitle'>{t("Promotion")}</h2>
          <hr className='bg-slate-500 w-[20%] mb-4' />
          <div className=' w-[15%] flex justify-around mt-4 mb-6'>
            <label className='text-xl font-medium font-persian' htmlFor="isAdmin"> {t("Admin")}</label>
            <input className='border border-slate-400' type="checkbox" id='isAdmin' checked={chechAdmin} onChange={handleCheck} />
          </div>
          <div className=' w-[50%] h-[15%] flex flex-col desktop:flex-row  gap-6 desktop:gap-0 justify-around items-center mt-3'>
            <button className='font-english bg-slate-300 hover:bg-slate-900 hover:text-slate-300 text-slate-900 text-xl  w-[60%] desktop:w-[30%] rounded-xl ' onClick={handleUpdate}>{t("submit")}</button>
            <Link to={'/users'} className='font-english bg-slate-300 hover:bg-slate-900 hover:text-slate-300 text-slate-900 text-xl w-[60%] desktop:w-[30%] rounded-xl text-center'>{t("back")}</Link>
          </div>
        </div>
  </div>
  )
}
